// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".eopoi-widget #poi-excursionticker-descriptions___wrapper.ellipsis-after p:last-child:after{content:\" …\"}", ""]);
// Exports
module.exports = exports;
